import React from "react";
import { SvgIcon, SvgIconProps } from "@mui/material";
const AppIconsCartFilled = React.forwardRef((props: SvgIconProps, ref: any) => {
  return (
    <SvgIcon {...props} ref={ref}>
      <g fill="currentColor">
        <path d="M23.1,4h0c0-.1-.2-.2-.3-.2H5.3l-.9-2.7c0-.2-.2-.3-.4-.3H.8v.3h0v.6h3c.5,1.5,1.1,3,1.6,4.5.5,1.5,1.1,3.1,1.6,4.6l.8,2.2-1.2,3.4c0,.1,0,.3,0,.4s.2.2.3.2h8.9c0,0,4.2,0,4.2,0,0,0,0,0,.1,0,0,0,0,0,.1,0,0-.1,0-.3,0-.4h0c0-.2,0-.3,0-.4h0s0,0,0,0c0,0-.1,0-.2,0H7.5l1-2.6,12.8-1.2c.2,0,.3-.1.4-.3l1.6-7.7c0-.1,0-.3,0-.4Z" />
        <path d="M8.8,18.1h0c-.7,0-1.3.3-1.8.7-.5.5-.7,1.1-.7,1.8,0,1.4,1.1,2.5,2.5,2.5s1.3-.3,1.8-.7c.5-.5.7-1.1.7-1.8s-.3-1.3-.7-1.8c-.5-.5-1.1-.7-1.8-.7ZM8.8,22.2c-.9,0-1.6-.7-1.6-1.6s.7-1.6,1.6-1.6,1.6.7,1.6,1.6-.7,1.6-1.6,1.6Z" />
        <path d="M17.5,18.2c-.7,0-1.3.3-1.8.7s-.7,1.1-.7,1.8c0,1.4,1.1,2.5,2.5,2.5s1.3-.3,1.8-.7.7-1.1.7-1.8c0-1.4-1.1-2.5-2.5-2.5ZM17.5,22.2c-.9,0-1.6-.7-1.6-1.6s.7-1.6,1.6-1.6,1.6.7,1.6,1.6-.7,1.6-1.6,1.6Z" />
      </g>
    </SvgIcon>
  );
});

export default AppIconsCartFilled;
